import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import React, { useRef, useState } from 'react';
import { PropTypes, describe } from 'react-desc';
import InfoCircleSmall from '@elliemae/ds-icons/InfoCircleSmall';
import useFocusGroupItem from '@elliemae/ds-shared/FocusGroup/useFocusGroupItem';
import DSModal, { MODAL_TYPE_V2 } from '@elliemae/ds-modal';
import { Pill } from './Pill.js';
import '@babel/runtime/helpers/esm/extends';
import '@babel/runtime/helpers/esm/objectWithoutProperties';
import '@babel/runtime/helpers/esm/defineProperty';
import '@elliemae/ds-classnames';

function ReadOnlyPill(_ref) {
  var _ref$containerProps = _ref.containerProps,
      containerProps = _ref$containerProps === void 0 ? {} : _ref$containerProps,
      _ref$modalContent = _ref.modalContent,
      modalContent = _ref$modalContent === void 0 ? '' : _ref$modalContent,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? '' : _ref$label,
      leftAddon = _ref.leftAddon,
      _ref$modalTitle = _ref.modalTitle,
      modalTitle = _ref$modalTitle === void 0 ? '' : _ref$modalTitle;
  var ref = useRef(null);

  var _useFocusGroupItem = useFocusGroupItem(ref);
      _useFocusGroupItem.focusPrevious;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isModalOpen = _useState2[0],
      setIsModalOpen = _useState2[1];

  var toggle = function toggle() {
    setIsModalOpen(!isModalOpen);
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Pill, {
    className: "removable-pill",
    containerProps: containerProps,
    innerRef: ref,
    label: label,
    leftAddon: leftAddon,
    rightAddon: /*#__PURE__*/React.createElement(InfoCircleSmall, {
      role: "button",
      className: "remove-pill-button",
      onClick: toggle,
      color: ['brand-primary', '600']
    }),
    tabIndex: -1
  }), /*#__PURE__*/React.createElement(DSModal, {
    isOpen: isModalOpen,
    showClose: true,
    shouldCloseOnOverlayClick: true,
    modalTitle: modalTitle,
    modalType: MODAL_TYPE_V2.INFORMATION,
    onClose: toggle,
    version: 2
  }, modalContent));
}

var props = {
  /** props injected to component wrapper */
  containerProps: PropTypes.object.description('props injected to component wrapper'),

  /** labeled pill text label */
  label: PropTypes.string.isRequired.description('pill text label'),

  /** addon component to left */
  leftAddon: PropTypes.node.description('addon component to left'),

  /** read only pill modal content */
  modalContent: PropTypes.string.description('read only pill modal content'),

  /** read only pill modal title */
  modalTitle: PropTypes.string.description('read only pill modal title')
};
ReadOnlyPill.propTypes = props;
var DSReadOnlyPillWithSchema = describe(ReadOnlyPill);
DSReadOnlyPillWithSchema.propTypes = props;

export { DSReadOnlyPillWithSchema, ReadOnlyPill };
//# sourceMappingURL=ReadOnlyPill.js.map
